import { useLoading as useUILoading } from '@desenvolvimento-intuix/ui-loading'

import { loadingConfig } from 'config/loading'

export const useLoading = () => {
  return useUILoading(loadingConfig)
}
